import { createContext, useContext, useEffect, useState } from "react";

const JWFilterContext = createContext(null);

const DEFAULT_FILTERS = {
    priceRange: [0, 1000000],
    caratRange: [0, 100],
    goldWtRange: [0, 250],

    styleNames: [],
    subCategoryNames: [],
    metalToneNames: [],
    goldQualityNames: [],
    itemSizeNames: [],

    collectionNames: [],   

    searchText: ""
};

export const JWFilterProvider = ({ children }) => {
    const [filters, setFilters] = useState(() => {
        const saved = localStorage.getItem("jwFilters");

        if (!saved) return DEFAULT_FILTERS;

        try {
            const parsed = JSON.parse(saved);

            return {
                ...DEFAULT_FILTERS,
                ...parsed,

                styleNames: Array.isArray(parsed.styleNames) ? parsed.styleNames : [],
                subCategoryNames: Array.isArray(parsed.subCategoryNames) ? parsed.subCategoryNames : [],
                metalToneNames: Array.isArray(parsed.metalToneNames) ? parsed.metalToneNames : [],
                goldQualityNames: Array.isArray(parsed.goldQualityNames) ? parsed.goldQualityNames : [],
                itemSizeNames: Array.isArray(parsed.itemSizeNames) ? parsed.itemSizeNames : [],
                priceRange: Array.isArray(parsed.priceRange) ? parsed.priceRange : DEFAULT_FILTERS.priceRange,
                caratRange: Array.isArray(parsed.caratRange) ? parsed.caratRange : DEFAULT_FILTERS.caratRange,
                goldWtRange: Array.isArray(parsed.goldWtRange) ? parsed.goldWtRange : DEFAULT_FILTERS.goldWtRange,
                collectionNames: Array.isArray(parsed.collectionNames)? parsed.collectionNames : [],
                searchText: parsed.searchText ?? ""
            };
        } catch {
            return DEFAULT_FILTERS;
        }
    });

    useEffect(() => {
        localStorage.setItem("jwFilters", JSON.stringify(filters));
    }, [filters]);

    const setRangeFilter = (key, range) => {
        setFilters(prev => ({
            ...prev,
            [key]: range
        }));
    };

    const toggleMultiSelect = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: prev[key].includes(value)
                ? prev[key].filter(v => v !== value)
                : [...prev[key], value]
        }));
    };

    const toggleSelectAll = (key, allValues) => {
        setFilters(prev => ({
            ...prev,
            [key]: prev[key].length === allValues.length ? [] : allValues
        }));
    };

    const removeSingleFilter = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: prev[key].filter(v => v !== value)
        }));
    };

    const setSearch = (value) => {
        setFilters(prev => ({
            ...prev,
            searchText: value
        }));
    };

    const setFilter = (key, values) => {
        setFilters(prev => ({
            ...prev,
            [key]: Array.isArray(values) ? values : [values]
        }));
    };

    const clearAllFilters = () => {
        setFilters(DEFAULT_FILTERS);
        localStorage.removeItem("jwFilters");
    };

    return (
        <JWFilterContext.Provider
            value={{
                filters,
                setRangeFilter,
                toggleMultiSelect,
                toggleSelectAll,
                removeSingleFilter,
                setSearch,
                setFilter,
                updateFilters: setFilters,
                clearAllFilters
            }}
        >
            {children}
        </JWFilterContext.Provider>
    );
};

export const useFilters = () => {
    const context = useContext(JWFilterContext);
    if (!context) {
        throw new Error("useFilters must be used inside JWFilterProvider");
    }
    return context;
};
